import { logger } from "@/lib/logger";

export function serviceErrorFallback<T>(scope: string, error: unknown, fallback: T): T {
  logger.error(scope, error);
  return fallback;
}

export function serviceErrorResult<T extends object>(
  scope: string,
  error: unknown,
  fallback: T
): T {
  return serviceErrorFallback(scope, error, fallback);
}

/**
 * `output: "export"` fails the whole build if a dynamic route's
 * generateStaticParams() resolves to zero entries (e.g. CMS collection is
 * currently empty). Fall back to one placeholder param so the route still
 * prerenders - the page's own `notFound()` handling turns it into a static
 * 404 instead of failing the build.
 */
export function ensureStaticParams<T extends Record<string, string>>(
  params: T[],
  placeholder: T
): T[] {
  return params.length > 0 ? params : [placeholder];
}

